import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ImpostModel } from 'app/main/shared/model/impost/impost.model';
import { SGF_API } from '../../../../../shared/api/sgf.api';

@Injectable({
  providedIn: 'root'
})
export class ImpostService {

  private host = `${SGF_API}` + 'sgf/api/public/imposto';

  constructor(
    private httpClient: HttpClient) {}

  findAll(): any {
    return this.httpClient.get<ImpostModel[]>(this.host, this.httpOptions())
      .pipe(
        catchError(this.handleError)
      );
  }

  create(impost: any): any {
    const body = JSON.stringify(impost);
    return this.httpClient.post(this.host, body, this.httpOptions())
      .pipe(
        catchError(this.handleError)
      );
  }

  update(impost: any): any {
    const body = JSON.stringify(impost);
    return this.httpClient.put(this.host, body, this.httpOptions())
      .pipe(
        catchError(this.handleError)
      );
  }

  httpOptions(token?: string): any {
    return {headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': ''
      })
    }}

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    return throwError(
      'Something bad happened; please try again later.');
  };

}
